import type { FaireProductEntity } from "../../entity_types/product";

export const p_idy9pbhj: FaireProductEntity = {
  token: "p_idy9pbhj",
  type: "product",
  name: "Welcome Little One Elephant Greeting Card",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/f211a9e1d2b1cc655e5521f4649a2b6bbf852e46070b767969b9ea06a34d0660.png",
  galleryImageUrls: [
    "https://cdn.faire.com/res/hszgttpjt/image/upload/262198cff80bab91228fd53a61ae91ceeb29af41ebbb94bf53475d2c54ad69bf/1528336561.png",
    "https://cdn.faire.com/fastly/cfe8da7f6c99ec8fe920566042dd04ee2c766c481973b1d425da5a4a4b2e744b.png",
  ],
  priceDollars: 3,
  description:
    "At E. Frances, we believe connection makes the world better. And happier! Our original artwork paired with just-right words warms the heart and helps make meaningful connections easier. Every card begins with a lovingly painted watercolor, and is then printed on luxurious heavyweight paper with brilliant color and, when featured, metallic foil accents.\n\nAnd because we think tiny details can make a big impact, you’ll always find a second illustration on the back of every card!",
  tags: [],
  msrpDollars: 6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:37:13.630Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
